import { ReactNode, FC } from 'react';
import { useTranslation } from 'react-i18next';
import PartnerScoreDataAvailability from '../PartnerScoreDataAvailability/PartnerScoreDataAvailability';
import { TestIds } from './testids';
import styles from './PartnerScoreContainer.module.scss';
import WidgetCard from '@/storybook/components/WidgetCard/WidgetCard';

type PartnerScoreContainerProps = {
  containerTitle: string;
  year: number;
  quarter: number;
  children: ReactNode;
};

const PartnerScoreContainer: FC<PartnerScoreContainerProps> = ({ containerTitle, year, quarter, children }) => {
  const { t } = useTranslation();

  return (
    <WidgetCard
      title={containerTitle}
      appearance="none"
      className={styles.boldHeadings}
      description={t('main.hcpOverview.overview.partnerscoreSummary.container.description')}
      data-testid={TestIds.container}
      description-testid={TestIds.description}
      displayContent={true}
    >
      <div data-testid={TestIds.children} className={styles.outletContainer}>
        <div data-testid={TestIds.dataAvailability}>
          <PartnerScoreDataAvailability
            year={year}
            quarter={quarter}
            initialTableVisible={false}
            currentAggregatedData="partners"
          />
        </div>
        {children}
      </div>
    </WidgetCard>
  );
};

export default PartnerScoreContainer;
